import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteUnit, getUnits } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const UnitList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleUnits();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteUnit(id, { archive: true });
            if (data.success) handleUnits();
        } catch (err) { }
    };

    const handleUnits = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getUnits(params);
            const { resultsPerPage, totalCount, units, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(units.map(unit => {
                return {
                    nameLocal: unit.nameLocal || '',
                    createdAt: unit.createdAt,
                    short: unit?.short || '',
                    isActive: unit.isActive,
                    name: unit.name || '',
                    _id: unit._id,
                }
            }));

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleUnits(page);
    };

    const AddUnit = () => navigate('/unit/create');
    const ImportUnit = () => { };

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_units',
                        title: 'unit_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                onClick: handleUnits,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_unit',
                                action: AddUnit,
                                icon: 'plus',

                            },
                            {
                                className: 'btn btn-added color',
                                title: 'import_unit',
                                action: ImportUnit,
                                icon: 'download',
                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleUnits} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={5}
                                type="unit"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UnitList;